module.exports = __webpack_public_path__ + "img/26_28.5c62a309.png";